import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/LoginView.vue';
import RegisterView from '../views/RegisterView.vue';
import MainLayout from '../components/layouts/MainLayout.vue';
import LoginLayout from '../components/layouts/LoginLayout.vue';

import store from '../store';

Vue.use(VueRouter);

const checkRoute = (to, from, next) => {
  const goToRote = () => {
    if (store.getters.isAuthenticated) {
      next();
    } else if (to.meta.openArea === true) {
      next();
    } else {
      next({ name: 'Login' });
    }
  };

  console.log('123');
  goToRote();
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      layout: MainLayout,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      layout: LoginLayout,
      openArea: true,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: {
      layout: LoginLayout,
      openArea: true,
    },
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(checkRoute);

export default router;
